function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCustomFillSm = function SvgIconCustomFillSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    stroke: props.color,
    d: "M3.75 3.75h16.5v16.5H3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M1.5 20.5h21"
  }));
};
export default SvgIconCustomFillSm;